import script from "./RecommendedMachines.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendedMachines.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendedMachines.vue?vue&type=style&index=0&id=1f2d616c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2d616c"]])

export default __exports__